import { render, staticRenderFns } from "./msg.vue?vue&type=template&id=ff052848&scoped=true&"
import script from "./msg.vue?vue&type=script&lang=js&"
export * from "./msg.vue?vue&type=script&lang=js&"
import style0 from "./msg.vue?vue&type=style&index=0&id=ff052848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff052848",
  null
  
)

export default component.exports